import {globals} from '@app/globals';
import {defineStore} from 'pinia';
import {DataService, ActionService} from '../../api';
import {applyCompanyCurrency} from '../../utils/currencyUtils';
import axios from 'axios';

const DEFAULT_CURRENCY = 'EUR';

function isValidUUID(uuid) {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

export const useCompanyProfileStore = defineStore('companyProfile', {
  state: () => ({
    uuid: '',
    name: '',
    locales: [],
    companyId: null,
    referralSystemDisabled: false,
    country: null,
    currency: DEFAULT_CURRENCY,
  }),

  getters: {
    keycloakId: (state) => state.uuid,
    addressId: (state) => state.companyId,
    referralSysEnabled: (state) => !state.referralSystemDisabled,
    companyCurrency: (state) => state.currency || DEFAULT_CURRENCY,
  },
  actions: {
    initCompanyStore() {
      this.uuid = globals.$appContext.companyId;
      this.name = globals.$appContext.companyName;
      return Promise.all([
        ActionService.get('referral/company/disabled').then((res) => {
          this.referralSystemDisabled = res.data;
        }),
        DataService.read('config', {
          attributes: 'value',
          filters: {label: 'eq.company.address.id'},
        }).then((response) => {
          if (response?.data?.length > 0) {
            if (isValidUUID(response.data[0].value)) {
              this.companyId = response.data[0].value;
            }
          }
        }),
        this.loadCompanyCurrency(),
        this.getCompanyDetails(),
      ]);
    },

    loadCompanyCurrency() {
      return DataService.read('config', {
        attributes: 'value',
        filters: {label: 'eq.company.currency'},
      }).then((response) => {
        this.setCurrency(response?.data?.[0]?.value, false);
      });
    },

    setCurrency(currency, applyToI18n = true) {
      this.currency = currency || DEFAULT_CURRENCY;
      if (applyToI18n) {
        applyCompanyCurrency(this.currency);
      }
    },

    applyCurrencyToI18n() {
      applyCompanyCurrency(this.companyCurrency);
    },

    getCompanyDetails() {
      const companyUrl = `${process.env.VUE_APP_ADMIN_API_URL}company/details`;

      return axios
        .get(companyUrl, {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            Authorization: `Bearer ${globals.$keycloak.token}`,
          },
        })
        .then((response) => {
          this.country = response.data[0].country;
          return response;
        });
    },
  },
});
